module.exports = __webpack_public_path__ + "img/user.cf111222.png";